import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import appStore from "../../src/assets/image/svg/appStroeIcon.svg";  // Replace with your image
import googlePlay from "../../src/assets/image/svg/googlePlayIcon.svg"; // Replace with your image
import HeroImage from "../../src/assets/image/png/heroImage.png"; 

const Hero = () => {
  return (
    <section className="py-5">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Content */}
          <div className="col-lg-6 text-center text-lg-start">
            <p className="text-uppercase clrTheme fw-bold fs_17 mb-2">
              Book Automotive, Salons, Spas, Sports Grounds &<br className="d-md-block d-none"></br> Restaurants with Vasta
            </p>
            <h1 className="fw-bold text-black fs_63 mb-3">
              Discover and Book Trusted Services Across Dubai
            </h1>
            <p className="text-muted mb-4">
              Book car care, salons, spas, sports grounds, and restaurants across Dubai all in one app. Vasta makes it simple to find, compare, and book trusted local businesses near you.
            </p>
            <div className="d-flex gap-3 justify-content-center justify-content-lg-start">
             
              <a href="https://apps.apple.com/us/app/vasta/id6752119785" target="_blanck">
                 <img src={appStore} alt="App Store" height="50" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.vasta&hl=en" target="_blanck">
                <img src={googlePlay} alt="Google Play" height="50" />
              </a>
            </div>
          </div>


          <div className="col-lg-6 text-center position-relative mt-5 mt-lg-0">
            <img
              src={HeroImage}
              alt="App screen 1"
              className="img-fluid position-relative"
              style={{ zIndex: 2 }}
            />

          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
